// extracted by mini-css-extract-plugin
export default {"summary":"MealsSummary_summary__z4tib"};